<template>
    <div class="flexy">
        <section class="hero">
            <div class="hero-body">
                <div class="level">
                    <div class="level-left">
                        <h1 class="title">Soferi</h1>
                    </div>
                    <div  class="level-right">
                        <button class="button is-primary" @click="add">
                            <span class="icon is-small">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            <span>Adauga</span>
                        </button>
                    </div>
                </div>
                <hr class="is-hidden-mobile" />
            </div>
        </section>
        <div class="has-text-centered">
            <b-field class="is-pulled-right is-clearfix">
                <b-input
                    placeholder="nume sau prenume ..."
                    type="input"
                    icon="magnify"
                    v-model="query"
                    @keyup.native.enter="search"
                ></b-input>
                <p class="control">
                    <button
                        class="button is-primary is-outlined"
                        size="is-large"
                        @click="search"
                    >
                        Cauta
                    </button>
                </p>
            </b-field>

            <div class="is-clearfix"></div>

            <loading-info />


            <div class="table-container " v-show="!isLoading">
                <b-table
                    :data="drivers.items"
                    :row-class="(row, index) => row.isExpired  && 'has-background-danger has-text-white	'"

                    :bordered="true"
                    :striped="true"
                    :narrowed="false"
                    :hoverable="true">
                    <template bordered  >
                        <b-table-column
                            field="name"
                            label="Nume"
                            v-slot="props"
                            >{{ props.row.name }}</b-table-column>

                        <b-table-column field="ci" label="Act identitate" v-slot="props">{{
                            props.row.ci
                        }}</b-table-column>
                         <b-table-column field="permit" label="Permis auto" v-slot="props">{{
                            props.row.permit
                        }}</b-table-column>
                        <b-table-column field="email"  label="Email alternativ" v-slot="props">{{
                            props.row.email
                        }}</b-table-column>
                        <b-table-column field="email"  label="Categorii" v-slot="props">{{
                            props.row.permitCategories
                        }}</b-table-column>
                        <!-- <b-table-column field="comments" label="Observatii">{{ props.row.comments }}</b-table-column> -->
                        <b-table-column label :centered="true" width="160" v-slot="props">
                            <button
                                class="button is-small is-rounded"
                                @click="edit(props.row)"
                            >
                                <span class="icon is-small">
                                    <i class="fa fa-edit"></i>
                                </span>
                            </button>
                            <button
                                class="button is-small is-rounded"
                                @click="del(props.row)"
                            >
                                <span class="icon is-small has-text-danger">
                                    <i class="fa fa-trash"></i>
                                </span>
                            </button>
                        </b-table-column>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">
                            <h1 class="is-size-5">
                                Nu am gasit nici o inregistrare.
                            </h1>
                            <div>
                                <button class="button is-text" @click="add">
                                    Adauga o inregistrare noua
                                </button>
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>

            <b-pagination
                v-show="!isLoading && driversList.length > 0"
                :total="drivers.total"
                :current.sync="page"
                :simple="false"
                :rounded="false"
                :per-page="drivers.perPage"
                @change="doPaginate"
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import Form from "@/components/DriverForm";
import LoadingInfo from "@/components/LoadingInfo";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
    name: "drivers",
    components: { LoadingInfo },
    data() {
        return {
            page: 1,
            query: "",
        };
    },
    computed: {
        ...mapGetters(["isLoading"]),
        ...mapState(["drivers"]),
        driversList() {
            return this.drivers.items || [];
        },
    },

    methods: {
        ...mapActions(["loadDrivers", "delDriver"]),
        search() {
            this.page = 1;
            this.doPaginate();
        },
        add: function () {
            this.$buefy.modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { reload: this.doPaginate },
            });
        },
        del(f) {
            this.$buefy.dialog.confirm({
                message: `Sigur stergem soferul: <b> ${f.name}</b> ?`,
                onConfirm: () => {
                    this.delDriver(f.id)
                        .then(() => {
                            this.doPaginate();
                            this.$buefy.toast.open("Sofer sters!");
                        })
                        .catch((err) => console.log(err));
                },
            });
        },
        edit: function (f) {
            this.$buefy.modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { driverId: f.id, reload: this.doPaginate },
            });
        },
        doPaginate(page) {
            page = page || 1;
            this.loadDrivers({ page: page, query: this.query });
        },
    },
    mounted() {
       this.doPaginate();
    },
};
</script>
